import isString from "lodash/isString";
import isArray from "lodash/isArray";

import { ErrorData } from "types/app";

function alertErrorMessage(responseData: ErrorData) {
  let errorMessage = "";

  if (isString(responseData)) return responseData.replace(/_/g, " ");
  errorMessage = responseData.message || "";

  if (responseData.error) {
    errorMessage = responseData.error.toString();
  }

  if (isArray(responseData.errors)) {
    errorMessage = responseData.errors.join("; ");
  }

  if (responseData.status >= 500 || !responseData.status) {
    errorMessage = "Something went wrong, please try again.";
  }

  if (errorMessage === "") {
    errorMessage = Object.keys(responseData)
      .map(key => {
        if (isString(responseData[key])) {
          return `${key} - ${responseData[key]}`;
        } else if (isArray(responseData[key])) {
          return `${key} - ${(responseData[key] as string[]).join(", ")}`;
        }

        return "";
      })
      .join("; ");
  }

  return errorMessage.replace(/_/g, " ");
}

export default alertErrorMessage;
